import { render, staticRenderFns } from "./ProductsDashboard.vue?vue&type=template&id=27e9a1f1&"
import script from "./ProductsDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports